<ng-container
  *flexyooLet="{
    isLoading: isLoading$ | async,
    quillDocumentId: quillDocumentId$ | async,
  } as data"
>
  @if (showConfirmButton()) {
    <button
      class="sign-button fo-color-secondary"
      matButton="filled"
      [disabled]="data.isLoading"
      (click)="confirmQuillSigned()"
    >
      {{ 'employee.benefit-' + documentType() + '-sign.confirm-button' | translate }}
    </button>
  }
  @if (showSignFlow()) {
    @if (data.quillDocumentId) {
      <span>
        {{ 'employee.benefit-' + documentType() + '-sign.submitted-description' | translate }}
      </span>
      @if (quillDocumentStatus$ | async; as quillDocumentStatus) {
        {{ 'employee.benefit-' + documentType() + '-sign.status.title' | translate }}
        {{
          'employee.benefit-' + documentType() + '-sign.status.' + quillDocumentStatus | translate
        }}
      }
      <button
        class="sign-button fo-color-secondary"
        matButton="filled"
        [disabled]="data.isLoading"
        (click)="updateStatus(data.quillDocumentId)"
      >
        {{ 'employee.benefit-' + documentType() + '-sign.update-status' | translate }}
      </button>
    }
    <span>{{ 'employee.benefit-' + documentType() + '-sign.sign-button-header' | translate }}</span>
    <button
      class="sign-button fo-color-secondary"
      matButton="filled"
      [class.sign-button_primary]="!data.quillDocumentId"
      [disabled]="data.isLoading"
      (click)="sign()"
    >
      <mat-icon>edit</mat-icon>
      {{ 'employee.benefit-' + documentType() + '-sign.sign-button' | translate }}
    </button>
  }
  @if (data.isLoading) {
    <flexyoo-loader class="loader"></flexyoo-loader>
  }
</ng-container>
